// extracted by mini-css-extract-plugin
export default {"link":"SocialMediaLink_link__ustA4","icons":"SocialMediaLink_icons__O-3jy"};